<template>
  <div>
    <div
      class="modal fade"
      id="DataCollectionModalStaticBackdrop"
      ref="dataCollectionModal"
      data-bs-backdrop="static"
      tabindex="-1"
      aria-label="DataCollectionModalLabel"
      aria-labelledby="DataCollectionModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header modal-title fw-bold w-100 fs-4">
            Data Collection Disclosure
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal(false)"
            ></button>
          </div>
          <div class="modal-body text-start p-4">
            <div v-if="!collectsData">
              <p class="mb-3">
                This application does not collect, store, or share any of your
                data.
              </p>
            </div>
            <div v-else>
              <p class="mb-3">
                This application requires some of your data to function.
              </p>
              <p class="mb-3">
                Here’s how your data is used and who can access it:
              </p>
              <div class="accordion mb-4 mt-4" id="dataAccordion">
                <!-- Name -->
                <div
                  v-for="data in collectedData"
                  :key="data.collectionType"
                  class="accordion-item"
                >
                  <h2
                    class="accordion-header"
                    :id="`heading${data.collectionType}`"
                  >
                    <button
                      class="accordion-button collapsed fs-5 text-muted fw-bold"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#collapse${formatTypeForId(
                        data.collectionType
                      )}`"
                      aria-expanded="false"
                      :aria-controls="`collapse${formatTypeForId(
                        data.collectionType
                      )}`"
                    >
                      {{ data.collectionType }}
                    </button>
                  </h2>
                  <div
                    :id="`collapse${formatTypeForId(data.collectionType)}`"
                    class="accordion-collapse collapse"
                    :aria-labelledby="`heading${formatTypeForId(
                      data.collectionType
                    )}`"
                    data-bs-parent="#dataAccordion"
                  >
                    <div class="accordion-body">
                      <p>
                        <strong>Why It’s Collected:</strong>
                        {{ data.collectionReason }}
                      </p>
                      <p>
                        <strong>Who Can See It:</strong>
                        {{ data.collectionAccess }}
                      </p>
                      <p v-if="data.collectionProtection">
                        <strong>How We Protect It:</strong>
                        {{ data.collectionProtection }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a
              v-for="(link, key) in resourceLinks"
              :key="key"
              :href="link"
              target="_blank"
            >
              {{ key }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";
import { collectedData } from "@/data/dataCollectionConfig";

export default {
  name: "DataCollectionModal",
  data() {
    return {
      modal: null,
      collectedData,
      resourceLinks: {
        "OSU Privacy Policy":
          "https://uit.oregonstate.edu/infosec/policies-rules/osu-privacy-policy"
      }
    };
  },
  props: {},
  methods: {
    openModal() {
      this.modal.show();
    },
    closeModal() {
      this.modal.hide();
    },
    // This is used to format the type for the id of the accordion item and the collapse item
    formatTypeForId(type) {
      return type.replace(/\s+/g, "");
    },
    // Validates that the required data is present for config file entries
    validateDataCollection() {
      for (const data of this.collectedData) {
        if (
          !data.collectionType?.length ||
          !data.collectionReason?.length ||
          !data.collectionAccess?.length
        ) {
          return false;
        }
      }
      return true;
    }
  },
  computed: {
    collectsData() {
      return this.collectedData.length > 0;
    }
  },
  mounted() {
    this.modal = new Modal(this.$refs.dataCollectionModal);
    // Throw an error if the data collection config is not valid
    if (!this.validateDataCollection()) {
      throw new Error("Data collection config is not valid");
    }
  }
};
</script>
